import React from "reactn";
import { Switch } from "@material-ui/core";
import { Icon } from "semantic-ui-react";

const AutomationCard = ({ automation, onToggle, onDelete, templates, onEdit }) => {
    const getTemplate = () => {
        console.log("automation", automation, templates);
        return templates.find(e => e.id == automation.templateId);
    }

    const getCommunicationIcon = () => {
        return automation.communicationType === "email" ? "mail" : "comment";
    };

    const getAutomationTypeText = () => {
        switch(automation.automationType) {
            case "reminder":
                return "Reminder";
            case "onboarding":
                return "Onboarding";
            case "enrollment-confirmation":
                return "Enrollment Confirmation";
            case "follow-up":
                return "Follow Up";
            case "auto-payment-reminder":
                return "Auto-payment Reminder";
            case "enrollment-reminder":
                return "Enrollment Reminder";
            case "milestone":
                return "Milestone";
            default:
                return "Automation";
        }
    };

    return (
        <div className="automation-card" style={{
            border: "1px solid #E5E5E5",
            borderRadius: "12px",
            padding: "24px",
            marginBottom: "20px",
            backgroundColor: "white",
            position: "relative",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            transition: "all 0.2s ease"
        }}>
            <div style={{ position: "absolute", top: "20px", right: "20px" }}>
                <Icon 
                    name={getCommunicationIcon()} 
                    style={{ 
                        fontSize: "1.5rem",
                        color: "rgb(196, 196, 199)"
                    }}
                />
            </div>

            <div style={{ marginBottom: "20px" }}>
                <h3 style={{ 
                    fontSize: "18px", 
                    fontWeight: "600",
                    marginBottom: "8px",
                    color: "#1f2937"
                }}>
                    {getAutomationTypeText()}
                </h3>
                <p style={{ 
                    color: "#666",
                    fontSize: "14px",
                    margin: "0"
                }}>
                    Template: {getTemplate() ? getTemplate().title : "Unknown"}
                </p>
                <p style={{ 
                    color: "#666",
                    fontSize: "14px",
                    margin: "0"
                }}>
                    For: {automation.automationFor}
                </p>
                <p style={{ 
                    color: "#666",
                    fontSize: "14px",
                    margin: "0"
                }}>
                    Timing: {automation.timing} {automation.timingUnit}
                </p>
            </div>

            <div style={{ 
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
            }}>
                <div style={{ display: "flex", gap: "12px" }}>
                    <Icon 
                        name="edit outline" 
                        style={{ 
                            cursor: "pointer", 
                            color: "#9ca3af",
                            fontSize: "1.2rem",
                            padding: "8px",
                            borderRadius: "6px",
                            transition: "all 0.2s ease"
                        }}
                        onClick={() => onEdit(automation)}
                    />
                    <Icon 
                        name="trash alternate outline" 
                        style={{ 
                            cursor: "pointer", 
                            color: "#9ca3af",
                            fontSize: "1.2rem",
                            padding: "8px",
                            borderRadius: "6px",
                            transition: "all 0.2s ease"
                        }}
                        onClick={() => onDelete(automation.id)}
                    />
                </div>

                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <span style={{ 
                        fontSize: "14px",
                        color: "#6b7280",
                        fontWeight: "500"
                    }}>
                        {automation.enabled ? "Active" : "Inactive"}
                    </span>
                    <Switch
                        checked={automation.enabled}
                        onChange={() => onToggle(automation.id)}
                        color="primary"
                        style={{
                            "& .MuiSwitch-switchBase": {
                                color: "#ffffff"
                            },
                            "& .MuiSwitch-track": {
                                backgroundColor: automation.enabled ? "#1a56db" : "#e5e7eb"
                            },
                            "& .MuiSwitch-thumb": {
                                backgroundColor: "#ffffff"
                            }
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default AutomationCard;